<div class="container-fluid content-page background">
    @if(!isLoading){
    <app-comments-declarations></app-comments-declarations>
    }
    <div class="columns is-multiline">
        <div class="column is-full">
            <div class="tabs is-fullwidth is-primary">
                <ul>
                    @for (tab of tabs; track tab.title) {
                    <li (click)="changeTab(tab)" class="is-active" [ngClass]="{'is-active' : tab.isActive}"><a>{{tab.title}}</a></li>
                    }
                </ul>
            </div>
        </div>
    </div>
    @if(tabs[0].isActive) {
        @if(!isLoading) {
            <app-prime-table [configTable]="configPrimeTable" (declarationChange)="onDeclarationChange($event)"></app-prime-table>
        } @else {
            <div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px;">
                <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner"/>
            </div>
        }
    }
    @if(tabs[1].isActive) {
        @if(!isLoading) {
            <app-prime-table
                [configTable]="configHistoricPrimeTable"
                (serverFilterChange)="onServerFilterChange($event)"
                (createAsociedDeclaration)="createRelatedDeclaration($event)">
            </app-prime-table>
            <div class="pagination-container">
                <app-pagination
                    [currentPage]="currentPage"
                    [totalPages]="maxPages"
                    (pageChange)="onHistoricPageChange($event)">
                </app-pagination>
            </div>
            <div class="column is-12" style="display: flex; justify-content: end;">
                <button class="button is-ghost download-button"
                    (click)="downloadResults()">
                    <fa-icon class="button-icon" [icon]="faDownload"></fa-icon>
                    Descargar resultados
                </button>
            </div>
        } @else {
            <div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px;">
                <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner"/>
            </div>
        }
    }
</div>
@if (selectedDeclarations.length > 1){
    <button class="button fab-button" (click)="goToMultipleGestion()">
        <fa-icon class="icon" [icon]="faSquareCheck"></fa-icon>
        Gestión Múltiple
    </button>
}
